import React from "react";
import propTypes from "prop-types";
import StarRatingComponent from "react-star-rating-component";

const style = {
  bloc: { display: "flex", width: "75%", margin: "auto" },
  label: {
    width: "45%",
    fontSize: "15px",
    fontWeight: "400"
  },
  star: { fontSize: "x-large", marginTop: "10px" }
};
const NotationBlock = ({ name, title }) => {
  return (
    <div style={style.bloc}>
      <h3 style={style.label}>{title} :</h3>
      <div style={style.star}>
        <StarRatingComponent
          name={name}
          type="rating"
          starCount={5}
          starColor="#f4dd0e"
          emptyStarColor="lightgray"
        />
      </div>
    </div>
  );
};

NotationBlock.propTypes = {
  name: propTypes.string.isRequired
};

export default NotationBlock;
